document.addEventListener('DOMContentLoaded', function () {
  
  const categoryData = {
    'stationery': {
      title: 'Stationery',
      themeColor: '#FFD166', /* Yellow */
      items: [
        { label: 'Pens', link: '/collections/pens' },
        { label: 'Pencils', link: '/collections/pencils' },
        { label: 'Erasers', link: '/collections/erasers' },
        { label: 'Sharpener', link: '/collections/sharpeners' },
        { label: 'Rulers & Measuring Tools', link: '/collections/rulers-and-measuring-tools' },
        { label: 'Full Scape & Spiral Notebook', link: '/collections/full-scape-and-spiral-notebook' },
        { label: 'Back To School', link: '/collections/back-to-school' },
        { label: 'School Supplies', link: '/collections/school-supplies' },
        { label: 'Marker & Refills', link: '/collections/markers' }
      ]
    },
    'notebook-fullscape': {
      title: 'Notebook & Full Scape',
      themeColor: '#4ECDC4', /* Mint Green */
      items: [
        { label: 'NR Notebooks', link: '/collections/nr-notebooks' },
        { label: 'M/C Notebooks', link: '/collections/m-c-notebooks' },
        { label: 'XAV Notebooks', link: '/collections/xav-notebooks' }
      ]
    },
    'office-supplies': {
      title: 'Office Supplies',
      themeColor: '#FF9F1C', /* Orange */
      items: [
        { label: 'Office Basics', link: '/collections/office-basics' },
        { label: "Office Add On's", link: '/collections/office-add-ons' },
        { label: 'Desk Accessories', link: '/collections/desk-accessories' },
        { label: 'Files & Folders', link: '/collections/files-and-folders' },
        { label: 'Office Utility', link: '/collections/office-utility' }
      ]
    },
    'art-craft': {
      title: 'Art & Craft Supplies',
      themeColor: '#F368E0', /* Pink */
      items: [
        { label: 'Paints', link: '/collections/paints' },
        { label: 'Art Pencils', link: '/collections/art-pencils' },
        { label: 'Crayons & Oil Pastels', link: '/collections/crayons-oil-pastels' },
        { label: 'Sketch & Connector Pens', link: '/collections/sketch-pens' },
        { label: 'Brush Pens & Fine Liners', link: '/collections/brush-pens-fine-liners' },
        { label: 'Brushes & Palette Knives', link: '/collections/brushes-palette-knives' },
        { label: 'Drawing Pads & Sheets', link: '/collections/watercolor-pads-and-sheets' },
        { label: 'Canvas Pads & Board', link: '/collections/canvas-pads-and-board' },
        { label: "Tool's", link: '/collections/tools' }
      ]
    },
    'pencil-cases': {
      title: 'Pencil Cases & Pouches',
      themeColor: '#9b59b6', /* Purple */
      items: [
        { label: 'View All Pencil Cases & Pouches', link: '/collections/pencil-cases-and-pouches' }
      ]
    },
    'textbooks': {
      title: 'Textbooks',
      themeColor: '#01A3A4', /* Teal */
      items: [
        { label: 'GSEB Textbooks', link: '/collections/gseb-text-books' },
        { label: 'NCERT Textbooks', link: '/collections/ncert-textbooks' },
        { label: 'Other Textbooks', link: '/collections/other-textbooks' }
      ]
    },
    'diaries': {
      title: 'Diaries',
      themeColor: '#FF6B6B', /* Red */
      items: [
        { label: 'Lock Style Diaries', link: '/collections/lock-style-diaries' },
        { label: 'Professional & Office Diaries', link: '/collections/professional-and-office-diaries' },
        { label: 'Spiral Style Diaries', link: '/collections/spiral-style-diaries' },
        { label: 'Fancy Diaries', link: '/collections/fancy-diaries' },
        { label: 'Aesthetic & Vintage Diaries', link: '/collections/ashtetic-vintage-diaries' },
        { label: 'Pocket Size Diaries', link: '/collections/pocket-size-diaries' }
      ]
    },
    'digest': {
      title: 'Digest',
      themeColor: '#54A0FF', /* Blue */
      items: [
        { label: 'Std. 6th Digest', link: '/collections/std-6th-digest' },
        { label: 'Std. 7th Digest', link: '/collections/std-7th-digest' },
        { label: 'Std. 8th Digest', link: '/collections/std-8th-digest' }
      ]
    },
    'fancy-product': {
      title: 'Fancy Products',
      themeColor: '#FF69B4', /* Hot Pink */
      items: [
        { label: 'View All Fancy Products', link: '/collections/fancy-product' }
      ]
    }
  };

  const overlay = document.getElementById('category-popup-overlay');
  const popupTitle = document.getElementById('category-popup-title');
  const popupIcon = document.getElementById('category-popup-icon');
  const popupList = document.getElementById('category-popup-list');
  const popupHeader = document.querySelector('.category-popup-header'); // Target the header
  const closeBtn = document.getElementById('category-popup-close');
  const tiles = document.querySelectorAll('.category-tile[data-cat-popup]');

  tiles.forEach(function (tile) {
    tile.addEventListener('click', function () {
      const key = this.getAttribute('data-cat-popup');
      const data = categoryData[key];

      if (!data) return;

      // 1. Set Title
      popupTitle.textContent = data.title;
      
      // 2. Set Dynamic Header Color
      if (popupHeader && data.themeColor) {
        popupHeader.style.backgroundColor = data.themeColor;
      }
      
      // 3. Clear previous icon and clone the SVG from the clicked tile
      popupIcon.innerHTML = '';
      const tileSvg = this.querySelector('.category-svg-icon');
      if (tileSvg) {
        const clonedSvg = tileSvg.cloneNode(true);
        clonedSvg.style.width = '36px';
        clonedSvg.style.height = '36px';
        clonedSvg.style.transform = 'none'; 
        clonedSvg.style.filter = 'none'; 
        popupIcon.appendChild(clonedSvg);
      }

      // 4. Populate List
      popupList.innerHTML = '';
      data.items.forEach(function (item) {
        const link = document.createElement('a');
        link.href = item.link;

        const labelSpan = document.createElement('span');
        labelSpan.textContent = item.label;

        const arrowSpan = document.createElement('span');
        arrowSpan.className = 'popup-item-arrow';
        arrowSpan.textContent = '→';

        link.appendChild(labelSpan);
        link.appendChild(arrowSpan);
        popupList.appendChild(link);
      });

      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  function closePopup() {
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

  // Scroll logic
  const grid = document.getElementById('category-grid');
  const leftBtn = document.getElementById('scroll-left');
  const rightBtn = document.getElementById('scroll-right');

  leftBtn.addEventListener('click', () => {
    grid.scrollBy({ left: -200, behavior: 'smooth' });
  });

  rightBtn.addEventListener('click', () => {
    grid.scrollBy({ left: 200, behavior: 'smooth' });
  });
});